import { Injectable } from '@angular/core';

import { environment } from '@app/environment';
import { AgencyConfigData } from '@app/models';
import { AgencyConfigFiles } from '../api.config';

@Injectable({
    providedIn: 'root'
})
export class AgencyService {

    private agencyConfigData: AgencyConfigData = new AgencyConfigData();

    constructor() { }
    
    init(){
        
        let agencyConfigFiles = new AgencyConfigFiles();
        let hostname = window.location.hostname;
        let configFile = agencyConfigFiles.defaultConfig;
        
        if (typeof agencyConfigFiles.hosts[hostname] !== 'undefined') {
            configFile = agencyConfigFiles.hosts[hostname];
        }
        
        if (typeof agencyConfigFiles.config[configFile] !== 'undefined') {
            this.agencyConfigData = agencyConfigFiles.config[configFile];
          }
    }
    
    getAgencyConfigData(): AgencyConfigData {
        return this.agencyConfigData;
    }
}

